"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTransformer = exports.RowTransformerValidator = void 0;

var RowTransformerValidator_1 = require("./RowTransformerValidator");

Object.defineProperty(exports, "RowTransformerValidator", {
  enumerable: true,
  get: function get() {
    return RowTransformerValidator_1.RowTransformerValidator;
  }
});

var HeaderTransformer_1 = require("./HeaderTransformer");

Object.defineProperty(exports, "HeaderTransformer", {
  enumerable: true,
  get: function get() {
    return HeaderTransformer_1.HeaderTransformer;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90cmFuc2Zvcm1zL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFBLHlCQUFBLEdBQUEsT0FBQSxDQUFBLDJCQUFBLENBQUE7O0FBQVMsTUFBQSxDQUFBLGNBQUEsQ0FBQSxPQUFBLEVBQUEseUJBQUEsRUFBQTtBQUFBLEVBQUEsVUFBQSxFQUFBLElBQUE7QUFBQSxFQUFBLEdBQUEsRUFBQSxlQUFBO0FBQUEsV0FBQSx5QkFBQSxDQUFBLHVCQUFBO0FBQXVCO0FBQXZCLENBQUE7O0FBQ1QsSUFBQSxtQkFBQSxHQUFBLE9BQUEsQ0FBQSxxQkFBQSxDQUFBOztBQUFTLE1BQUEsQ0FBQSxjQUFBLENBQUEsT0FBQSxFQUFBLG1CQUFBLEVBQUE7QUFBQSxFQUFBLFVBQUEsRUFBQSxJQUFBO0FBQUEsRUFBQSxHQUFBLEVBQUEsZUFBQTtBQUFBLFdBQUEsbUJBQUEsQ0FBQSxpQkFBQTtBQUFpQjtBQUFqQixDQUFBIiwic291cmNlUm9vdCI6IiJ9